import { createContext, RefObject, useContext, useRef } from 'react';
import { ChildrenOnly } from '../common/types/ChildrenOnly';

const RootContext = createContext<RefObject<HTMLDivElement> | undefined>(undefined);

export const RootContextProvider = ({ children }: ChildrenOnly) => {
  const rootElementRef = useRef(null);

  return (
    <div ref={rootElementRef}>
      <RootContext.Provider value={rootElementRef}>{children}</RootContext.Provider>
    </div>
  );
};

export const useRootContext = () => useContext(RootContext);
